import React, { useEffect, useState } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';

import { ChangePassword, EditProfile, Notifications, TeamDetails } from 'components/organisms/Profile';
import { useAuth } from 'contexts/auth';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/Profile/mobile';
import Tablet from 'pages/Profile/tablet';
import Desktop from 'pages/Profile/desktop';
import { AlertDialog } from 'shell/components';

const ProfilePage = () => {
    const { auth } = useAuth();
    const { isLoading, currentGroup } = useUser2();
    const { device, width } = useViewport();

    const [onBeforeChange, setOnBeforeChange] = useState({ action: (proceed) => proceed() });
    const [selected, setSelected] = useState(device === 'mobile' ? '' : 'edit-profile');
    const [alertDialog, setAlertDialog] = useState({
        open: false,
        message: '',
        description: '',
        note: '',
        variant: 'destructive',
        actionButtonText: 'Leave',
        cancelButtonText: 'Cancel',
        onAction: () => {},
        onCancel: () => setAlertDialog((current) => ({ ...current, open: false })),
        onClose: () => setAlertDialog((current) => ({ ...current, open: false })),
    });

    const getContent = (key) => {
        return {
            'edit-profile': (
                <EditProfile
                    setSelected={setSelected}
                    setAlertDialog={setAlertDialog}
                    setOnBeforeChange={setOnBeforeChange}
                />
            ),
            'change-password': <ChangePassword setSelected={setSelected} />,
            'team-details': <TeamDetails setSelected={setSelected} />,
            notifications: <Notifications setSelected={setSelected} />,
        }[key];
    };

    const panelList = {
        LTI: {
            student: [
                { key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') },
                { key: 'team-details', value: 'Team Details', content: getContent('team-details') },
                { key: 'notifications', value: 'Notification Preferences', content: getContent('notifications') },
            ],
            instructor: [
                { key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') },
                { key: 'notifications', value: 'Notification Preferences', content: getContent('notifications') },
            ],
        },
        PASSWORD: {
            student: [
                { key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') },
                { key: 'change-password', value: 'Change Password', content: getContent('change-password') },
                { key: 'team-details', value: 'Team Details', content: getContent('team-details') },
                { key: 'notifications', value: 'Notification Preferences', content: getContent('notifications') },
            ],
            instructor: [
                { key: 'edit-profile', value: 'Edit Profile', content: getContent('edit-profile') },
                { key: 'change-password', value: 'Change Password', content: getContent('change-password') },
                { key: 'notifications', value: 'Notification Preferences', content: getContent('notifications') },
            ],
        },
    };

    const props = {
        options: panelList[process.env.REACT_APP_AUTH][auth?.role],
        selected,
        onBeforeChange: onBeforeChange.action,
        onChange: setSelected,
    };

    const responsiveLayouts = {
        mobile: <Mobile {...props} />,
        tablet: <Tablet {...props} />,
        desktop: <Desktop {...props} />,
    };

    useEffect(() => {
        if ((device === 'tablet' || device === 'desktop') && !selected) {
            setSelected('edit-profile');
        }
    }, [device]);

    useEffect(() => {
        setOnBeforeChange({ action: (proceed) => proceed() });
    }, [selected]);

    if (isLoading) return <LogoLoading />;

    if (auth.role === 'student' && !currentGroup) return <LogoLoading />;

    return (
        <>
            {withResponsiveLayout(width, responsiveLayouts)}
            <AlertDialog {...alertDialog} />
        </>
    );
};

export default ProfilePage;
